/**
 * Renders `count` with the correct English singular/plural noun (e.g. "1 walk", "3 walks").
 * For irregular plurals, pass `plural` explicitly (e.g. pluralize(2, "person", "people")).
 */
export function pluralize(count: number, singular: string, plural?: string): string {
  const word = count === 1 ? singular : (plural ?? `${singular}s`);
  return `${count} ${word}`;
}
